import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取课程类型列表
 * @param {*} params 
 */
export function getCoursetypes(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/coursetype/coursetypes',
        method: 'get',
        params: param
    })
}

/**
 * 删除指定id的课程类型
 * @param {*} id 
 */
export function deleteCoursetype(id) {
    return request({
        url: '/api/manager/coursetype/'+id,
        method: 'delete'
    })
}

/**
 * 添加预约类型
 * @param {}} param 
 */
export function addCoursetype(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/coursetype',
        method: 'post',
        data: data
    })
}

/**
 * 修改预约类型
 * @param {}} param 
 */
export function editCoursetype(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/coursetype',
        method: 'put',
        data: data
    })
}